module.exports = __webpack_public_path__ + "static/img/04.5a17a31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/raz_frauenfeld/04.jpg
// module id = 443
// module chunks = 1